import { render } from "./VatTuDinhMucTable.vue?vue&type=template&id=25e4cead&ts=true"
import script from "./VatTuDinhMucTable.vue?vue&type=script&lang=ts"
export * from "./VatTuDinhMucTable.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__